module.exports = __webpack_public_path__ + "media/assets/img/authot_studio_footer_logo-82acd5c4afaca1bd4a6d4cacf436bbf3.png";